// import store from 'store';
import _store from 'store/next.ts';
// that'll need to be updated. store will eventually become the default. . .

export default () => {
  if (parent === window) {
    return _store as any;
  }

  try {
    if (parent.getStore) {
      return parent.getStore();
    }
  } catch {
    return _store;
  }

  return _store;
};
